































































import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '@/models/commonVue';
import Modal from './Modal.vue';
import DropDownEntity from './DropDownEntity.vue';
import Dimmer from './Dimmer.vue';
import ApiList from '@/api/list';
import Module from '@/api/module';
import Lesson from '@/api/lesson';
import Exercise from '@/api/exercise';
import { BusEvent } from '@/models/bus';
import Submodule from '@/api/submodule';
import { copyLesson } from '@/util/copy-content/copy-lesson';
import { isNil } from 'lodash';
import axios, { AxiosResponse } from 'axios';
import config from '@/config';
import store from '@/store';

@Component({
  components: {
    modal: Modal,
    'drop-down-entity': DropDownEntity,
    dimmer: Dimmer
  }
})
export default class CopyModule extends CommonVue {
  @Prop({ type: Lesson }) public lesson!: Lesson;

  public moduleList: ApiList<Module> = null;
  @Model() public moduleId!: number;

  public submodules: ApiList<Submodule> = null;
  @Model() public subModuleId!: number;
  public showModal: boolean = false;

  public async beforeMount() {
    await this.load();
  }

  private async load() {
    this.moduleList = await Module.listAll();
  }

  @Watch('moduleId')
  public async loadSubModules(value: number, oldValue: number) {
    try {
      this.submodules = await Submodule.getSubmodulesOfModule(this.moduleId);
    } catch (e) {
      this.error = true;
      this.$bus.$emit(BusEvent.ERROR, 'Could not get submodule information', e);
    }
  }

  public async copyClicked() {
    const confirm = this.askConfirmation();
    if (confirm) {
      this.busy = true;
      try {
        const result = await copyLesson(
          this.lesson,
          this.moduleId,
          this.subModuleId
        );

        this.busy = false;
        this.close();
      } catch (error) {
        this.busy = false;
        this.close();
        this.$bus.$emit(BusEvent.ERROR, 'Could not copy lesson', error);
      }
    }
  }

  private askConfirmation() {
    let answer = false;
    if (this.submodules || !(this.moduleId === undefined)) {
      answer = window.confirm(
        'Do you really want to copy content to this module?'
      );
    } else {
      answer = window.confirm('You need to choose module, sub-module to copy!');
    }
    return answer;
  }

  public async show() {
    this.showModal = true;
  }

  public async close() {
    this.showModal = false;
    this.moduleList = null;
    this.submodules = null;
  }
}
